var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-[12px] text-[#333333] overflow-hidden",class:_vm.containerClass},[_c('h4',{staticClass:"text-[12px] font-medium text-[#626262] mb-[4px]"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }